import { Component, OnInit, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import postscribe from 'postscribe';

@Component({
  selector: 'app-wizaz-rating',
  templateUrl: './wizaz-rating.component.html',
  styleUrls: ['./wizaz-rating.component.scss']
})
export class WizazRatingComponent implements AfterViewInit {

  private _id: number;

  @Input() set id(id: number) {
    this._id = id;
  }

  get id() {
    return this._id;
  }

  elementId;

  constructor(
    private readonly router: Router
  ) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.renderWidget();
        console.log('this.renderWidget();');
      }
    });
  }

  ngAfterViewInit() {
    this.renderWidget();
  }

  renderWidget() {
    this.elementId = Math.random().toString(36).substring(7);
    setTimeout(() => {
      postscribe(`#rating_${this.elementId}`, `<script async data-id="9de857a17de8e4de42aebc5c5ebe94ce" data-params-id="${this.id}"src="https://c2c.edipresse.pl/script/init.js" ></script>`);
    });
  }
}
